(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this._handleClick = this.handleClick.bind(this);
      this._handleKeydown = this.handleKeydown.bind(this);
      this.addEventListener('click', this._handleClick);
      document.addEventListener('keydown', this._handleKeydown);
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this._handleKeydown);
    }

    handleClick(e) {
      if (e.target.closest('.cart-drawer__close') || e.target.matches('.cart-drawer__overlay')) {
        this.close();
        return;
      }

      const qtyBtn = e.target.closest('.cart-drawer__qty-btn');
      if (qtyBtn) {
        const key = qtyBtn.dataset.key;
        const delta = parseInt(qtyBtn.dataset.delta, 10);
        const valEl = qtyBtn.closest('.cart-drawer__qty').querySelector('.cart-drawer__qty-val');
        const next = Math.max(0, parseInt(valEl.textContent, 10) + delta);
        this.changeQuantity(key, next);
        return;
      }

      const removeBtn = e.target.closest('.cart-drawer__remove');
      if (removeBtn) {
        this.changeQuantity(removeBtn.dataset.key, 0);
      }
    }

    handleKeydown(e) {
      if (e.key === 'Escape' && this.getAttribute('aria-hidden') === 'false') {
        this.close();
      }
    }

    open() {
      this.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      this.querySelector('.cart-drawer__panel').focus();
    }

    close() {
      this.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    setLoading(on) {
      this.classList.toggle('is-loading', on);
    }

    async renderContents() {
      const res = await fetch('/?sections=cart-drawer');
      const data = await res.json();
      const doc = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
      const fresh = doc.querySelector('cart-drawer');

      // Replace scrollable items area
      const newScrollable = fresh.querySelector('#CartDrawerScrollable');
      const curScrollable = this.querySelector('#CartDrawerScrollable');
      if (newScrollable && curScrollable) {
        curScrollable.innerHTML = newScrollable.innerHTML;
      }

      // Replace / add / remove footer
      const newFooter = fresh.querySelector('#CartDrawerFooter');
      const curFooter = this.querySelector('#CartDrawerFooter');
      if (newFooter && curFooter) {
        curFooter.innerHTML = newFooter.innerHTML;
      } else if (newFooter && !curFooter) {
        this.querySelector('.cart-drawer__panel').appendChild(newFooter.cloneNode(true));
      } else if (!newFooter && curFooter) {
        curFooter.remove();
      }

      // Update title count
      const newCount = fresh.querySelector('.cart-drawer__count');
      const curCount = this.querySelector('.cart-drawer__count');
      const title = this.querySelector('.cart-drawer__title');
      if (newCount && curCount) {
        curCount.textContent = newCount.textContent;
      } else if (newCount && !curCount) {
        title.appendChild(newCount.cloneNode(true));
      } else if (!newCount && curCount) {
        curCount.remove();
      }

      // Sync header cart bubble
      const count = newCount ? parseInt(newCount.textContent.replace(/[()]/g, ''), 10) : 0;
      this.updateHeaderBubble(count);
    }

    updateHeaderBubble(count) {
      const btn = document.getElementById('CartIconBtn');
      if (!btn) return;
      let sup = btn.querySelector('sup');
      if (count > 0) {
        if (!sup) {
          sup = document.createElement('sup');
          btn.prepend(sup);
        }
        sup.textContent = count;
        btn.setAttribute('aria-label', 'Cart (' + count + ')');
      } else {
        if (sup) sup.remove();
        btn.setAttribute('aria-label', 'Cart');
      }
    }

    async changeQuantity(key, quantity) {
      this.setLoading(true);
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: quantity })
        });
        if (!res.ok) throw new Error('Cart update failed');
        await this.renderContents();
      } finally {
        this.setLoading(false);
      }
    }
  }

  customElements.define('cart-drawer', CartDrawer);

  // Reusable ATC wrapper — wraps any product form to open the cart drawer
  class AjaxCartForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.btn = this.querySelector('[type="submit"]');
      if (!this.form || !this.btn) return;
      this.form.addEventListener('submit', this.onSubmit.bind(this));
    }

    async onSubmit(e) {
      e.preventDefault();
      const originalText = this.btn.textContent;
      this.btn.disabled = true;
      this.btn.textContent = 'Adding...';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          body: new FormData(this.form)
        });
        if (!res.ok) throw new Error('Add to cart failed');

        const drawer = document.querySelector('cart-drawer');
        if (drawer) {
          await drawer.renderContents();
          drawer.open();
        }

        this.btn.textContent = '✓ Added!';
        setTimeout(() => {
          this.btn.textContent = originalText;
          this.btn.disabled = false;
        }, 1500);
      } catch (err) {
        console.error('[ATC]', err);
        this.btn.textContent = originalText;
        this.btn.disabled = false;
      }
    }
  }

  customElements.define('ajax-cart-form', AjaxCartForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const hamburger = document.querySelector('.header__hamburger');
  const mobileMenu = document.getElementById('mobile-menu');
  const closeBtn = document.querySelector('.mobile-menu__close');
  const overlay = document.querySelector('.mobile-menu__overlay');

  function openMenu() {
    mobileMenu.classList.add('is-open');
    overlay.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    hamburger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    mobileMenu.classList.remove('is-open');
    overlay.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    hamburger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  hamburger.addEventListener('click', openMenu);
  closeBtn.addEventListener('click', closeMenu);
  overlay.addEventListener('click', closeMenu);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeMenu();
  });

  // Open cart drawer instead of navigating to cart page
  const cartIconBtn = document.getElementById('CartIconBtn');
  if (cartIconBtn) {
    cartIconBtn.addEventListener('click', (e) => {
      const drawer = document.querySelector('cart-drawer');
      if (drawer) {
        e.preventDefault();
        drawer.open();
      }
    });
  }

  // Localization form custom element — Dawn pattern
  if (!customElements.get('localization-form')) {
    customElements.define('localization-form', class LocalizationForm extends HTMLElement {
      connectedCallback() {
        this.btn = this.querySelector('.localization-selector__btn');
        this.list = this.querySelector('.localization-selector__list');
        this.hiddenInput = this.querySelector('input[name="country_code"]');
        this.form = this.querySelector('form');

        this.btn.addEventListener('click', () => this.toggle());
        this.querySelectorAll('.localization-selector__option').forEach((a) => {
          a.addEventListener('click', (e) => {
            e.preventDefault();
            this.select(a.dataset.value);
          });
        });

        this.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') this.close();
        });

        document.addEventListener('click', (e) => {
          if (!this.contains(e.target)) this.close();
        });
      }

      toggle() {
        this.list.hidden ? this.open() : this.close();
      }

      open() {
        this.list.hidden = false;
        this.btn.setAttribute('aria-expanded', 'true');
      }

      close() {
        this.list.hidden = true;
        this.btn.setAttribute('aria-expanded', 'false');
      }

      select(value) {
        this.hiddenInput.value = value;
        this.form.submit();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
